module.exports = __webpack_public_path__ + "img/rewards50.992afab.svg";